<mat-dialog-content>
  <div class="notes_popup_overlay">
    <div class="notes_popup">
      <div class="notes_title">Add notes<a class="material-icons" mat-dialog-close>close</a></div>
      <div class="user_name">International application details</div>
      <div class="textarea_sec" [ngClass]="{'input_error': showErrorMsg$()}">
        <ng-container>
          <quill-editor class="ckEditorFields" (onEditorCreated)="util.onQuillCreated($event)" [(ngModel)]="intlNotes" [modules]="util.ckEditorVal" [maxlength]="totalCharCount$()" (ngModelChange)="getCharCount()" (keydown)="commonFn.restrictSpace($event, intlNotes)" [placeholder]="'Type a note'"></quill-editor>
        </ng-container>
        @if (showErrorMsg$()) {
          <div class="error_msg">
            <p>International application details cannot exceed more than {{totalCharCount$()}} characters</p>
          </div>
        }
      </div>
      <div class="buttons_sec">
        <div class="text_count">{{notesCharCount$()}}/{{totalCharCount$()}}</div>
        <div class="btn_group">
          <button mat-stroked-button (click)="clearIntlNotes()">CLEAR</button>
          <button mat-stroked-button [ngClass]="{'active':(intlNotes.trim().length)}"
          [disabled]="!intlNotes.trim().length" (click)="saveIntlNotesData()">SAVE</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>